<div class="footer">
  <div class="wrap">

    <div class="link">
      <h2 class="sr-only">하단메뉴영역</h2>
      <ul>
        <li><a routerLink="/contents" [queryParams]="{menu_seq:118}">오시는 길</a></li>
        <li><a routerLink="/contents" [queryParams]="{menu_seq:407}">개인정보처리방침</a></li>
        <li><a routerLink="/contents" [queryParams]="{menu_seq:411}">이메일무단수집거부</a></li>
      </ul>
    </div>

    <div class="company">
      <h2 class="sr-only">회사 정보</h2>
      <div class="logo-area">
	      <div class="fl">
	        <a routerLink="/main" class="footer-logo">
	          <img src="/assets/images/footer_logo.png" alt="로고" />
	        </a>
	      </div>
	      <div class="sns fr">
	        <a href="https://www.facebook.com/hvacr.kraia" target="_blank">
	          <img src="/assets/images/facebook.png" alt="facebook" />
	        </a>
	        <a href="https://twitter.com/kraiasns" target="_blank">
	          <img src="/assets/images/twitter.png" alt="twitter" />
	        </a>
	      </div>
      </div>
      <div class="cb"></div>
      <div class="address">
              한국냉동공조산업협회<span></span>대표 강성희<br class="mobile-only"><span class="pc-only"></span>사업자등록번호 116-82-01412<br/>
        06170 서울시 강남구 봉은사로 622(삼성동) 공조회관 5층<br class="mobile-only"><span class="pc-only"></span>Tel : 02-2193-4300<span></span>Fax : 02-785-1195
      </div>
    </div>

    <div class="copyright">Copyright ⓒ 2019 한국냉동공조산업협회. All Rights Reserved.</div>
  </div>
</div>